import React, { useState } from "react";
import { VoteStart } from './voteStartCount';
import { MdInsertComment, MdStar } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import Vote, { ratingVote } from './vote';
import ViewVoteStarButton from './ViewVoteStarButton';
import UserComment from './userComment';
import './CommentaireUser.css';
import { elakayAutoText } from "../dataElakay";

const CommentaireUser = ({
    infoSource,
    voteA,
    comments,
    token,
    productId,
    loadProductsView,
    ButtonAddComments,
    showComments,
    setUserVote,
    SetSizeComments,
    setCommentsPro,
    commentProduct,
    setSkip,
    size,
    skip,
    limit,
    setShowComments,
    ButtonBool = true
}) => {
    const [VoteNumSt, setVoteNumSt] = useState();
    const [CoUsSt, setCoUsSt] = useState(false);

    let voteRating = voteA && ratingVote(voteA);

    let st5 = `${VoteStart(voteA, 5)}`;
    let st4 = `${VoteStart(voteA, 4)}`;
    let st3 = `${VoteStart(voteA, 3)}`;
    let st2 = `${VoteStart(voteA, 2)}`;
    let st1 = `${VoteStart(voteA, 1)}`;

    const ButtonStcchoose = (a, b, N) => {
        if (a > 0) {
            if (VoteNumSt === N) {
                setCoUsSt(false);
                setVoteNumSt();
            } else {
                setCoUsSt(b);
                setVoteNumSt(N);
            }
        }
    };

    const ProgressVote = () => (
        <div className="vote-summary-card">
            <div className="vote-rating-display">
                <span className="rating-number">
                    {parseFloat(voteRating ? voteRating : 0).toFixed(1)}
                </span>
                <div className="rating-stars">
                    {voteRating ? (
                        <Vote productID={productId} token={token} rating={voteRating} />
                    ) : (
                        <Vote productID={productId} token={token} rating={0} />
                    )}
                </div>
                <p className="rating-count">
                    {voteA ? voteA?.length : 0} {voteA?.length > 1 ? elakayAutoText("h_auto_review_plural_lower", "reviews") : elakayAutoText("h_auto_review_singular_lower", "review")}
                </p>
            </div>
        </div>
    );

    const RatingProgressBar = ({ stars, percentage, onClick }) => (
        <div className="rating-progress-row" onClick={onClick}>
            <div className="rating-stars-label">
                {stars} <MdStar className="star-icon" />
            </div>
            <div className="rating-progress-bar">
                <div
                    className="rating-progress-fill"
                    style={{ width: `${percentage}%` }}
                />
            </div>
            <div className="rating-percentage">
                {Math.round(percentage)}%
            </div>
        </div>
    );

    const TableProgressVote = () => (
        <div className="vote-progress-table">
            <RatingProgressBar
                stars={5}
                percentage={parseFloat(st5)}
                onClick={() => ButtonStcchoose(st5, true, 5)}
            />
            <RatingProgressBar
                stars={4}
                percentage={parseFloat(st4)}
                onClick={() => ButtonStcchoose(st4, true, 4)}
            />
            <RatingProgressBar
                stars={3}
                percentage={parseFloat(st3)}
                onClick={() => ButtonStcchoose(st3, true, 3)}
            />
            <RatingProgressBar
                stars={2}
                percentage={parseFloat(st2)}
                onClick={() => ButtonStcchoose(st2, true, 2)}
            />
            <RatingProgressBar
                stars={1}
                percentage={parseFloat(st1)}
                onClick={() => ButtonStcchoose(st1, true, 1)}
            />
        </div>
    );

    const CommentsByRating = (st) => {
        if (!CoUsSt) return null;

        return comments?.map((k, i) =>
            voteA.slice(1, 3)?.map((v, j) => {
                if (k.user === v.userId && v.voteNum === st) {
                    return (
                        <div key={j} className="comment-by-rating">
                            {/* Render comment content here */}
                        </div>
                    );
                }
                return null;
            })
        );
    };

    return (
        <div className="commentaire-section">
            <div className="commentaire-container">
                <div className="commentaire-wrapper">
                    {/* Header */}
                    <div className="commentaire-header">
                        <h3 className="commentaire-title">
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).customerReviews}
                        </h3>
                    </div>

                    {/* Rating Summary */}
                    {/* <div className="rating-summary-section">
                        <div className="rating-summary-grid">
                            <div className="rating-summary-left">
                                <ProgressVote />
                            </div>
                            <div className="rating-summary-right">
                                <TableProgressVote />
                            </div>
                        </div>
                    </div> */}

                    {/* Vote Star Button */}
                    <div className="vote-button-section">
                        <ViewVoteStarButton
                            infoSource={infoSource}
                            setVoteNumSt={setVoteNumSt}
                            VoteNumSt={VoteNumSt}
                            voteA={voteA}
                            token={token}
                            productId={productId}
                            loadProductsView={loadProductsView}
                            ButtonAddComments={ButtonAddComments}
                            showComments={showComments}
                        />
                    </div>

                    {/* Comments List */}
                    <div className="comments-list-section">
                        <UserComment
                            infoSource={infoSource}
                            skip={skip}
                            limit={limit}
                            setCommentsPro={setCommentsPro}
                            commentProduct={commentProduct}
                            SetSizeComments={SetSizeComments}
                            setUserVote={setUserVote}
                            comments={comments}
                            voteA={voteA}
                            productId={productId}
                            token={token}
                            size={size}
                            ButtonBool={false}
                        />
                        {CommentsByRating(VoteNumSt)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommentaireUser;
